import React from "react";

const LazyRegister = React.lazy(() => import(/* webpackChunkName: "Register" */ "./register"));

const Register = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyRegister {...props} />
  </React.Suspense>
);

export default Register;
